import { trackingService } from '../../tracking';
import { TrackerType } from '../enums';
import { PRODUCT_NAME, PARTNER_ID } from './constants';

export const trackMobileNavPrescriptionClick = (userId?: string): void => {
  trackingService.trackEvent(
    'PRESCRIPTION',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'bottom nav',
      surface: 'list',
      flow: 'prescrever',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackMobileNavHistoryClick = (userId?: string): void => {
  trackingService.trackEvent(
    'HISTORY',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'bottom nav',
      surface: 'list',
      flow: 'histórico',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackMobileNavProfileClick = (userId?: string): void => {
  trackingService.trackEvent(
    'PROFILE',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'bottom nav',
      surface: 'list',
      flow: 'perfil',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};

export const trackMobileNavMoreClick = (userId?: string): void => {
  trackingService.trackEvent(
    'MORE',
    PRODUCT_NAME,
    {
      page: 'bem-vindo',
      route: '',
      placement: 'bottom nav',
      surface: 'list',
      flow: 'mais opções',
      step: 'inicio',
      element: 'button',
      action: 'click',
      user_id: userId || '',
      token: '',
      partner_id: PARTNER_ID,
    },
    [TrackerType.MEVO_TRACKER]
  );
};
